import React from "react";
import { injectIntl } from "react-intl";
import Propertii from "../../common/Propertii";
import EftReport from "../../common/ReportEfts";

class ReportEfts extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The company EFT report component.
     */
    render() {

        return(
            <EftReport companyId={this.props.match.params.companyId} />
        )
    };
}

export default injectIntl(ReportEfts);